import React from 'react';
import RRModal from 'react-responsive-modal';
import styled, { css } from 'styled-components';
import { MaxWidth } from '../../base';

const Modal = ({
  className,
  onClose,
  open,
  fullscreen,
  showCloseButton: _showCloseButton,
  ...rest
}) => {
  const showCloseButton = _showCloseButton || fullscreen;
  return (
    <RRModal
      classNames={{ modal: 'modal', overlay: className, closeButton: 'closeButton' }}
      onClose={onClose}
      open={open}
      focusTrapped={showCloseButton}
      showCloseIcon={showCloseButton}
      {...rest}
    />
  );
};

export default styled(Modal)`
  .modal {
    padding: 0 !important;
    border-radius: 4px;
  }

  .closeButton {
    z-index: 10;
  }

  ${props =>
    props.fullscreen &&
    css`
      .modal {
        width: 100%;
      }
    `}
`;
